import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SliderContainer = styled.div`
  height: ${603 * Screen.widthRatio}px;
`;

export default SliderContainer;
